import { render, staticRenderFns } from "./VideoCarousel.vue?vue&type=template&id=644ef764&scoped=true&lang=pug&"
import script from "./VideoCarousel.vue?vue&type=script&lang=js&"
export * from "./VideoCarousel.vue?vue&type=script&lang=js&"
import style0 from "./VideoCarousel.vue?vue&type=style&index=0&id=644ef764&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "644ef764",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/jackie/sites/cardinalco/ylang-23/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('644ef764')) {
      api.createRecord('644ef764', component.options)
    } else {
      api.reload('644ef764', component.options)
    }
    module.hot.accept("./VideoCarousel.vue?vue&type=template&id=644ef764&scoped=true&lang=pug&", function () {
      api.rerender('644ef764', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/scripts/components/video/VideoCarousel.vue"
export default component.exports